import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  Output,
} from "@angular/core";

@Component({
  selector: "dua-popover",
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: "./popover.component.html",
  styleUrls: ["./popover.component.scss"],
})
export class PopoverComponent {
  @Input() dismissable = true;
  @Input() placement: "below" | "above" = "below";
  @Output() onShow = new EventEmitter<void>();
  @Output() onHide = new EventEmitter<void>();

  visible = false;
  private armed = false;
  private showToken = 0;

  constructor(private host: ElementRef<HTMLElement>) {}

  @HostBinding("class.above")
  get opensAbove(): boolean {
    return this.placement === "above";
  }

  toggle(_event?: Event): void {
    if (this.visible) {
      this.hide();
    } else {
      this.show();
    }
  }

  show(): void {
    if (this.visible) {
      return;
    }

    this.visible = true;
    this.armed = false;
    this.onShow.emit();

    const token = ++this.showToken;
    setTimeout(() => {
      if (this.showToken === token && this.visible) {
        this.armed = true;
      }
    });
  }

  hide(): void {
    if (!this.visible) {
      return;
    }

    this.visible = false;
    this.armed = false;
    this.onHide.emit();
  }

  @HostListener("document:click", ["$event"])
  onDocumentClick(event: MouseEvent): void {
    if (!this.visible || !this.dismissable || !this.armed) {
      return;
    }

    const target = event.target as Node | null;
    if (target && this.host.nativeElement.contains(target)) {
      return;
    }

    this.hide();
  }
}
